<script>
	import listBase from '@_system/components/base/list.vue'
	import settlementtree from '../lib/datetree/tree.vue'
	import statistics from './lib/statistics/index.vue'
	import editIndex from './lib/edit/index.vue'
	export default {
		extends: listBase,
		name: 'purchaseoutstockbillIndex',
		props: {

		},
		render(h) {
			this.$slots.aside = [ <settlementtree ref = "settlementtree"key = {this.settlementtreeKey} onSelect = {this.settlementtreeChange}/>
			]
			this.$slots.header = [
				<el-breadcrumb separator-class="el-icon-arrow-right" >
					{
						this.parentbread.length!=0?this.parentbread.map((item,index)=>{
						return <el-breadcrumb-item key={index}>{item.name}</el-breadcrumb-item>
					}):<el-breadcrumb-item>{'采购出库单'}</el-breadcrumb-item>
					
					}			
				</el-breadcrumb>
			]
			this.$slots.plug = [
				<statistics nodeid={this.nodeid} ref="statistics" onExportdetail={this.exportdetail} />,
				<editIndex title="更换结算单" row={this.currentrow} onSuccess={this.editSuccess} ref="purchasesoutckbillEdit" />
			]	
			return listBase.render.call(this, h)
		},
		data() {
			return {
				asideWidth: 150,
				moduleName: 'purchaseoutstockbill',
				windowName: '采购出库单',
				windowType: 'modal',
				settlementtreeKey: Math.random(),
				nodeid: [],
				parentbread: [],
				currentrow: null,
				currentrcvinfo: null,
				currentpayinfo:null,
				mkcodetitle: '',
	
				
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			//this.foreingKey.settlementtype = '8805,8825'
		},
		computed: {

		},

		methods: {
			editformShow(row){
				console.log(row)
				this.currentrow = row
				this.$refs.purchasesoutckbillEdit.modalShow()
			},
			importpanel() {
				this.$refs[this.importRef].importcomfig = ()=>{
					let res = [{
						code: "stockCode",
						require: true,
						title: "单据编码",
						unique: false,
					},{
						code: "voucherno",
						require: false,
						title: "凭证号",
						unique: false,
					}]
					return Promise.resolve(res)
				}
				this.$refs[this.importRef].importpanel()	
			},
			statistics(){
				if(this.nodeid.length==0){
					this.$message.error('请选择时间')
					return
				}
				this.$refs.statistics.modalShow()
			},
			exportdetail(e){
				console.log(e)
				this.$refs[this.moduleName+'_list'].exportData({
					data:e.data,
					type: 'xlsx',
					remote:false
				})
			},
			// cellClick({row,column}){
			// 	if(column.field==''){
					
			// 	}
			// 	console.log(row,column)
			// },
			beforeCreateGrid(formConfig,columns){
				columns.forEach((item)=>{
					if(item.field == 'haspaper'){
						item.align = 'center'
						item.cellRender = {
							name:'$switch',
							enabled:true,
							props:{
								openLabel:'有',
								closeLabel:'无',
								openValue:5,
								closeValue:6,
								size:'medium',
							},
							events:{
								change:({row})=>{
									this.switchChnage(row)
								}
							}
						}
					}
					if(item.field == 'signfor'){
						item.align = 'center'
						item.cellRender = {
							name:'$switch',
							enabled:true,
							props:{
								openLabel:'是',
								closeLabel:'否',
								openValue:5,
								closeValue:6,
								size:'medium',
							},
							events:{
								change:({row})=>{
									this.switchChnage(row)
								}
							}
						}
					}
				})
				console.log(columns)
			},
			switchChnage(row){
				this.$api.purchaseoutstockbill.update(row.id,{haspaper:row.haspaper,signfor:row.signfor})
			},
			settlement(row) {
				let handle = this.$loading()
				this.$api.reconciliationcurrent.settlement({
					wlnid: row.supplierID,
					purchasecode: row.billCode,
					stockCode:row.stockCode,
					type: 7,
				}).then(() => {
					this.$loadingclose(handle)
					this.$message.success('操作成功')
					this.customreload()

				}, () => {
					this.$loadingclose(handle)
				})
				console.log(row)
			},
			settlementtreeChange(e) {
				console.log(e)
				this.parentbread = []
				this.nodeid = e.parentid != 0 ? [e.id] : e.childrenid
				if (e.parentid != 0) {
					this.parentbread.push({
						id: e.parentid,
						name: e.parentid
					})
				}
				this.parentbread.push({
					id: e.id,
					name: e.name
				})

				// this.gridOptions.pagerConfig = {
				// 	currentPage: 1,
				// 	pageSize: 20,
				// }
				this.customreload()
			},
			editSuccess(){
				
			},
			beforeexport (obj,type) {
				return new Promise((resolve,reject)=>{
					if(type=='total'){
						if(this.nodeid.length==0){
							this.$message.error('请选择月份')
							reject()
						}else{
							obj.nodeid = this.nodeid
							resolve()
						}	
					}else{
						resolve()
					}

				})
			},
			beforeRequest(form) {
				form.nodeid = this.nodeid
			},
		},
		components: {
			editIndex
		}
	}
</script>